var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"container is-fluid is-marginless app-content"},[_c('level-bar'),_c('router-view')],1),_c('div',{staticStyle:{"display":"none"},attrs:{"id":"downloadCsvSection"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }